export interface CredentialsInterface {
  username: string;
  password: string;
}

export class Credentials implements CredentialsInterface {
  public username: string;
  public password: string;

  constructor(username: string, password: string) {
    this.username = username;
    this.password = password;
  }
}
